import type { ReactElement } from 'react';

/**
 * La firma: «Hecho por [isotipo] Compartimentar». Último elemento del contenido,
 * nunca fija. Centrada en el alta (`hecho-por--centro`), a la izquierda en el resto.
 *
 * El isotipo es el oficial, calcado de `LOGO EN NEGRO.png`
 * (`public/compartimentar-isotipo.svg`). Va como máscara CSS y no en línea: son
 * 21 kB que así no entran en el bundle de arranque, y la máscara deja que tome
 * el color del texto.
 *
 * `rel="noopener"` no es burocracia: sin él, la página que se abre recibe una
 * referencia a esta ventana por `window.opener` y puede redirigirla. Y
 * `noreferrer` evita mandar la URL de la app —que puede llevar identificadores
 * en la ruta— a un servidor externo.
 */
export function HechoPor({ className = '' }: { className?: string }): ReactElement {
  return (
    <p className={`hecho-por ${className}`.trim()}>
      <span>Hecho por</span>
      <a href="https://compartimentar.tech" target="_blank" rel="noopener noreferrer">
        <span className="hecho-por__isotipo" aria-hidden="true" />
        Compartimentar
      </a>
    </p>
  );
}
